import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";

export default function AuthCallback() {
  const { googleLogin } = useAuth();
  const location = useLocation();
  const nav = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    googleLogin(sessionId).then((res) => {
      if (!res.ok) {
        toast.error(res.error || "Google sign-in failed");
        nav("/login", { replace: true });
        return;
      }
      const needsWa = res.user.role !== "admin" && !res.user.whatsapp_number;
      nav(needsWa ? "/complete-profile" : "/dashboard", { replace: true });
    });
  }, [googleLogin, location.hash, nav]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="font-mono-fig text-sm text-muted-foreground">Signing you in…</div>
    </div>
  );
}
